/**
 * Stripe processing fee constants
 * These values represent Stripe's standard processing fees for US cards
 *
 * Fee structure: percentage fee + fixed fee per transaction
 * Standard US card fee: 2.9% + $0.30
 */

const STRIPE_PROCESSING_FEE_PERCENTAGE = 0.029 // 2.9%
const STRIPE_PROCESSING_FEE_FIXED = 0.3 // $0.30
export const MINIMUM_DONATION_AMOUNT = 1 // $1

/** Set on website donation Checkout Sessions so thank-you webhooks can skip other Stripe checkouts. */
export const STRIPE_WEBSITE_DONATION_METADATA_KEY = 'mahaaction_org_site_donation' as const
export const STRIPE_WEBSITE_DONATION_METADATA_VALUE = 'true' as const

/** Set on membership Checkout Sessions so membership webhooks can identify the plan. */
export const STRIPE_WEBSITE_MEMBERSHIP_METADATA_KEY = 'mahaaction_org_site_membership' as const
export const STRIPE_WEBSITE_MEMBERSHIP_METADATA_VALUE = 'true' as const
export const STRIPE_MEMBERSHIP_LEVEL_METADATA_KEY = 'membershipLevelId' as const

// We send back the Payload user's email, not the one they paid with
export const STRIPE_MEMBERSHIP_USER_EMAIL_METADATA_KEY = 'userEmail' as const

/** True when url is a hosted Stripe Checkout session from our membership API. */
export function isAllowedStripeCheckoutUrl(url: string): boolean {
  try {
    const parsed = new URL(url)
    return parsed.protocol === 'https:' && parsed.hostname.toLowerCase() === 'checkout.stripe.com'
  } catch {
    return false
  }
}

/**
 * Calculate the amount to charge so that after Stripe's fee, the net amount equals the desired donation
 * This solves: chargeAmount - fee(chargeAmount) = desiredAmount
 * @param desiredAmount - The desired net donation amount in dollars
 * @returns The amount to charge (including the processing fee) in dollars
 */
export const calculateAmountWithFee = (desiredAmount: number): number => {
  // Solve: X - (X * 0.029 + 0.30) = desiredAmount
  // X - X * 0.029 - 0.30 = desiredAmount
  // X * (1 - 0.029) = desiredAmount + 0.30
  // X = (desiredAmount + 0.30) / (1 - 0.029)
  return (desiredAmount + STRIPE_PROCESSING_FEE_FIXED) / (1 - STRIPE_PROCESSING_FEE_PERCENTAGE)
}
